import { render } from "./PriceInforTable.vue?vue&type=template&id=58ca8782&scoped=true"
import script from "./PriceInforTable.vue?vue&type=script&lang=js"
export * from "./PriceInforTable.vue?vue&type=script&lang=js"

import "./PriceInforTable.vue?vue&type=style&index=0&id=58ca8782&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ca8782"]])

export default __exports__